import { FC } from 'react';
import { cn } from '@/shared/lib';
import { TruncatedText } from '@/shared/ui';

/** Строка легенды: образец цвета и то, что этот цвет означает. */
export type ChartLegendItem = {
  /** Класс заливки образца — тот же цвет, каким окрашен сам элемент диаграммы */
  colorClass: string;
  label: string;
};

type Props = {
  items: ChartLegendItem[];
};

/**
 * Легенда диаграммы: перечень «цвет — что он означает» под рисунком.
 *
 * Стоит под рисунком и переносится по строкам, а не колонкой сбоку: сбоку она отнимала бы у
 * рисунка ширину, и чем больше в ней строк, тем меньше оставалось бы самой диаграмме.
 *
 * Показана там, где цвет сам по себе не назван, — у круговой диаграммы и у диаграммы, окрашенной
 * правилами величины. Там, где название стоит у самого элемента, легенды нет: она повторяла бы
 * уже написанное.
 */
export const ChartLegend: FC<Props> = ({ items }) => {
  if (items.length === 0) return null;

  return (
    <ul className="flex flex-wrap items-center gap-x-4 gap-y-1 pt-2">
      {/* Ключ по месту в перечне: подписи двух правил могут совпасть, а цвета у них разные */}
      {items.map((item, index) => (
        <li key={index} className="flex min-w-0 items-center gap-1.5">
          <span className={cn('size-2.5 shrink-0 rounded-full', item.colorClass)} />
          <TruncatedText className="text-xs text-muted-foreground">{item.label}</TruncatedText>
        </li>
      ))}
    </ul>
  );
};
